module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Life Individual"},"fr":{"title":"Vie individuel"}}')
  delete Component.options._Ctor
}
